<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      ref="addModal"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის მენიუ ჯგუფების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameAdd"
                      class="form-control"
                      placeholder="სახელი"
                      autofocus="autofocus"
                      v-model="merchant.name"
                      v-on:input="$v.merchant.$touch"
                      v-bind:class="{
                        'error-border': $v.merchant.name.$error,
                        valid:
                          $v.merchant.name.$dirty && !$v.merchant.name.$invalid,
                      }"
                    />
                    <label for="nameAdd">სახელი</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="number"
                      id="districtIdAdd"
                      class="form-control"
                      placeholder="districtId"
                      v-model="merchant.districtId"
                      v-on:input="$v.merchant.$touch"
                      v-bind:class="{
                        'error-border': $v.merchant.districtId.$error,
                        valid:
                          $v.merchant.districtId.$dirty &&
                          !$v.merchant.districtId.$invalid,
                      }"
                    />
                    <label for="districtIdAdd">districtId</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="text"
                      id="addressAdd"
                      class="form-control"
                      placeholder="მისამართი"
                      v-model="merchant.address"
                      v-on:input="$v.merchant.$touch"
                      v-bind:class="{
                        'error-border': $v.merchant.address.$error,
                        valid:
                          $v.merchant.address.$dirty &&
                          !$v.merchant.address.$invalid,
                      }"
                    />
                    <label for="addressAdd">მისამართი</label>
                  </div>
                  <div class="form-group form-check mt-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="statusAdd"
                      v-model="merchant.status"
                    />
                    <label class="form-check-label" for="statusAdd"
                      >სტატუსი</label
                    >
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="number"
                      id="phoneAdd"
                      class="form-control"
                      placeholder="ტელეფონი"
                      v-model="merchant.phone"
                      v-on:input="$v.merchant.$touch"
                      v-bind:class="{
                        'error-border': $v.merchant.phone.$error,
                        valid:
                          $v.merchant.phone.$dirty &&
                          !$v.merchant.phone.$invalid,
                      }"
                    />
                    <label for="phoneAdd">ტელეფონი</label>
                  </div>
                  <div class="form-label-group mt-3">
                    <input
                      type="text"
                      id="emailAdd"
                      class="form-control"
                      placeholder="მეილი"
                      v-model="merchant.email"
                      v-on:input="$v.merchant.$touch"
                      v-bind:class="{
                        'error-border': $v.merchant.email.$error,
                        valid:
                          $v.merchant.email.$dirty &&
                          !$v.merchant.email.$invalid,
                      }"
                    />
                    <label for="emailAdd">მეილი</label>
                  </div>
                  <div class="form-label-group">
                    <div class="dropdown mt-3">
                      <button
                        class="btn green-color text-light dropdown-toggle"
                        type="button"
                        id="dropdownLegalSelect"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ dropDownLegal }}
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownLegalSelect"
                        style="max-height: 400px; overflow: hidden auto"
                      >
                        <a
                          class="dropdown-item pointer"
                          v-for="legalValue in LegalsArray"
                          :key="legalValue.id"
                          v-on:focus="$v.merchant.$touch"
                          @click="
                            dropDownLegalClick(legalValue.name, legalValue.id)
                          "
                          v-bind:class="{
                            'error-border': $v.merchant.legalId.$error,
                            valid:
                              $v.merchant.legalId.$dirty &&
                              !$v.merchant.legalId.$invalid,
                          }"
                          >{{ legalValue.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-label-group">
                    <div class="dropdown mt-3">
                      <button
                        class="btn green-color text-light dropdown-toggle"
                        type="button"
                        id="dropdownLegalBrandSelect"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {{ dropDownLegalBrand }}
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownLegalBrandSelect"
                        style="max-height: 400px; overflow: hidden auto"
                      >
                        <a
                          class="dropdown-item pointer"
                          v-for="legalBrandValue in LegalBrandsArray"
                          :key="legalBrandValue.id"
                          v-on:focus="$v.merchant.$touch"
                          @click="
                            dropDownLegalBrandClick(
                              legalBrandValue.nameGe,
                              legalBrandValue.id
                            )
                          "
                          v-bind:class="{
                            'error-border': $v.merchant.legalBrandId.$error,
                            valid:
                              $v.merchant.legalBrandId.$dirty &&
                              !$v.merchant.legalBrandId.$invalid,
                          }"
                          >{{ legalBrandValue.nameGe }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActive"
              type="button"
              class="btn btn-success"
              :disabled="!$v.merchant.$dirty || $v.merchant.$error"
              @click="$v.merchant.$touch(), addMerchant()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActive"
              type="button"
              class="btn btn-success"
              :disabled="!$v.merchant.$dirty || $v.merchant.$error"
              @click="$v.merchant.$touch(), editMerchant()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">მისამართი</th>
            <th class="numeric">მეილი</th>
            <th class="numeric">ტელეფონი</th>
            <th class="numeric">რედაქტირება</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in MerchantsArray" :key="value.id">
            <td data-title="სახელი" class="numeric">{{ value.name }}</td>
            <td data-title="მისამართი" class="numeric">{{ value.address }}</td>
            <td data-title="მეილი" class="numeric">{{ value.email }}</td>
            <td data-title="ტელეფონი" class="numeric">{{ value.phone }}</td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editFillInputs(value), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">ორგანიზაციის რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
                      <div class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="nameEdit"
                                class="form-control"
                                placeholder="სახელი"
                                autofocus="autofocus"
                                v-model="merchant.name"
                                v-on:input="$v.merchant.$touch"
                                v-bind:class="{'error-border': $v.merchant.name.$error, valid: $v.merchant.name.$dirty && !$v.merchant.name.$invalid}"
                              >
                              <label for="nameEdit">სახელი</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="number"
                                id="districtIdEdit"
                                class="form-control"
                                placeholder="districtId"
                                v-model="merchant.districtId"
                                v-on:input="$v.merchant.$touch"
                                v-bind:class="{'error-border': $v.merchant.districtId.$error, valid: $v.merchant.districtId.$dirty && !$v.merchant.districtId.$invalid}"
                              >
                              <label for="districtIdEdit">districtId</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="addressEdit"
                                class="form-control"
                                placeholder="имя на русском"
                                v-model="merchant.address"
                                v-on:input="$v.merchant.$touch"
                                v-bind:class="{'error-border': $v.merchant.address.$error, valid: $v.merchant.address.$dirty && !$v.merchant.address.$invalid}"
                              >
                              <label for="addressEdit">имя на русском</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="emailEdit"
                                class="form-control"
                                placeholder="email"
                                v-model="merchant.email"
                                v-on:input="$v.merchant.$touch"
                                v-bind:class="{'error-border': $v.merchant.email.$error, valid: $v.merchant.email.$dirty && !$v.merchant.email.$invalid}"
                              >
                              <label for="emailEdit">email</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="statusEdit"
                                v-model="merchant.status"
                              >
                              <label class="form-check-label" for="statusEdit">სტატუსი</label>
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="phoneEdit"
                                class="form-control"
                                placeholder="ტელეფონი"
                                v-model="merchant.phone"
                                v-on:input="$v.merchant.$touch"
                                v-bind:class="{'error-border': $v.merchant.phone.$error, valid: $v.merchant.phone.$dirty && !$v.merchant.phone.$invalid}"
                              >
                              <label for="phoneEdit">ტელეფონი</label>
                            </div>
                            <div class="form-label-group">
                              <div class="dropdown mt-3">
                                <button
                                  class="btn green-color dropdown-toggle"
                                  type="button"
                                  id="dropdownProductCategorySelectEdit"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >{{dropDownLegal}}</button>
                                <div class="dropdown-menu" aria-labelledby="dropdownProductCategorySelectEdit">
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="legalValue in LegalsArray"
                                    :key="legalValue.id"
                                    v-on:focus="$v.merchant.$touch"
                                    @click="dropDownLegalClick(legalValue.name, legalValue.id)"
                                    v-bind:class="{'error-border': $v.merchant.legalId.$error, valid: $v.merchant.legalId.$dirty && !$v.merchant.legalId.$invalid}"
                                  >{{legalValue.name}}</a>
                                </div>
                              </div>
                            </div>
                            <div class="form-label-group">
                              <div class="dropdown mt-3">
                                <button
                                  class="btn green-color dropdown-toggle"
                                  type="button"
                                  id="dropdownProductSubCategorySelectEdit"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >{{dropDownLegalBrand}}</button>
                                <div class="dropdown-menu" aria-labelledby="dropdownProductSubCategorySelectEdit">
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="legalBrandValue in LegalBrandsArray"
                                    :key="legalBrandValue.id"
                                    v-on:focus="$v.merchant.$touch"
                                    @click="dropDownLegalBrandClick(legalBrandValue.nameGe, legalBrandValue.id)"
                                    v-bind:class="{'error-border': $v.merchant.legalBrandId.$error, valid: $v.merchant.legalBrandId.$dirty && !$v.merchant.legalBrandId.$invalid}"
                                  >{{legalBrandValue.nameGe}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.merchant.$dirty || $v.merchant.$error"
              @click="$v.merchant.$touch(), editMerchant()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteMerchant()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";
import { baseURL } from "../../settings/settings.js";

const _baseUrl = baseURL + "api/merchant/1.0/";

export default {
  name: "merchant",
  data() {
    return {
      showModal: false,
      merchant: {
        id: "",
        name: "",
        districtId: null,
        legalId: null,
        legalBrandId: null,
        status: false,
        address: "",
        email: "",
        phone: "",
        personalID: null,
      },
      legal: {
        id: "",
        identificationCode: "",
        name: "",
        password: "",
        physicalAddress: "",
        legalAddress: "",
        mobile: "",
        email: "",
        dirFirstName: "",
        dirLastName: "",
        hasMerchant: false,
        merchantCout: 0,
        hasLoyalty: false,
      },
      legalBrand: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        logoSrc: null,
        lBCategoryId: null,
        merchants: [],
      },
      isActive: false,
      dropDownLegal: "აირჩიეთ ორგანიზაცია",
      dropDownLegalBrand: "აირჩიეთ ლეგალ ბრენდი",
      LegalsArray: [],
      LegalBrandsArray: [],
      MerchantsArray: [],
    };
  },
  validations: {
    merchant: {
      name: {
        required,
      },
      districtId: {
        required,
      },
      legalId: {
        required,
      },
      legalBrandId: {
        required,
      },
      address: {
        required,
      },
      email: {
        required,
      },
      phone: {
        required,
      },
      personalID: {
        required,
      },
    },
  },
  async created() {
    let merchantResult = await this.$http.getMerchant();
    this.MerchantsArray = merchantResult.data.res;

    let legalResult = await this.$http.getLegal();
    this.LegalsArray = legalResult.data.res;

    let leglaBrandResult = await this.$http.getLegalBrand();
    this.LegalBrandsArray = leglaBrandResult.data.res;
  },
  methods: {
    async addMerchant() {
      try {
        // let productMenuGroupObjectAdd = {
        //   nameGe: this.merchant.nameGe,
        //   nameEn: this.merchant.nameEn,
        //   nameRu: this.merchant.nameRu,
        //   order: this.merchant.order,
        //   prodCategoryId: this.merchant.prodCategoryId,
        //   prodSubCategoryId: this.merchant.prodSubCategoryId,
        //   showInSubs:
        //     this.merchant.showInSubs === null
        //       ? false
        //       : this.merchant.showInSubs,
        //   showOnDashboard:
        //     this.merchant.showOnDashboard === null
        //       ? false
        //       : this.merchant.showOnDashboard,
        //   showOnlyDashboard:
        //     this.merchant.showOnlyDashboard === null
        //       ? false
        //       : this.merchant.showOnlyDashboard,
        //   showOnlyMain:
        //     this.merchant.showOnlyMain === null
        //       ? false
        //       : this.merchant.showOnlyMain,
        //   showOnMain:
        //     this.merchant.showOnMain === null
        //       ? false
        //       : this.merchant.showOnMain,
        //   products: this.merchant.products
        // }
        let merchantAddResult = await this.$http.postMerchant(this.merchant);
        if (merchantAddResult.data.resultCode.status === "200") {
          bus.$emit("success", "მაღაზია წარმატებით დაემატა");
          let merchantResult = await this.$http.getMerchant();
          this.MerchantsArray = merchantResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editMerchant() {
      try {
        let merchantEditResult = await this.$http.putMerchant(this.merchant);
        if (merchantEditResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით დარედაქტირდა");
          let merchantResult = await this.$http.getMerchant();
          this.MerchantsArray = merchantResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteMerchant() {
      try {
        let merchantDeleteResult = await this.$http.post(
          _baseUrl + "delete-merchant",
          { id: this.merchant.id }
        );
        if (merchantDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის მენიუ გრუპი წარმატებით წაიშალა");
          let merchantResult = await this.$http.getMerchant();
          this.MerchantsArray = merchantResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის მენიუ გრუპის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      // this.modalPrepare()
      // this.merchant = Object.assign({}, row)
      let merchantResult = await this.$http.getByIDMerchant(row.id);

      this.merchant = merchantResult.data.res;
      console.log(this.merchant);
      // if (row.prodCategoryId === null) {
      //   let legalByID = await this.$http.post(_baseUrl + 'get-prod-sub-category', { id: row.prodSubCategoryId })
      //   this.subCategory = productSubCategoryByID.data.res
      //   let productSubCategoryResult = await this.$http.post(_baseUrl + 'get-all-prod-sub-categories-full', { id: this.subCategory.categoryId })
      //   this.productSubCategoriesArray = productSubCategoryResult.data.res
      // } else {
      //   this.dropDownProductCategory = this.getProductCategoryName(row.prodCategoryId)
      // }
      // this.dropDownLegald = this.getLegalName(row.legalId)
      let legalResult = await this.$http.getByIDLegal(row.legalId);
      this.dropDownLegal = legalResult.data.res.name;

      // this.dropDownLegalBrand = this.getLegalBrandName(row.legalBrandId)
      let legalBrandResult = await this.$http.getByIDLegalBrand(
        row.legalBrandId
      );
      this.dropDownLegalBrand = legalBrandResult.data.res.nameGe;
    },
    getDeleteId(id) {
      this.merchant.id = id;
    },
    // getLegalName (id) {
    //   let legalIndex = this.LegalsArray.findIndex(d => d.id === id)
    //   if (legalIndex !== -1) {
    //     return this.LegalsArray[legalIndex].name
    //   }
    // },
    // getLegalBrandName (id) {
    //   let legalBrandIndex = this.LegalBrandsArray.findIndex(d => d.id === id)
    //   if (legalBrandIndex !== -1) {
    //     return this.LegalBrandsArray[legalBrandIndex].nameGe
    //   } else {
    //     return 'აირჩიეთ ქვე კატეგორია'
    //   }
    // },
    async dropDownLegalClick(legalName, legalId) {
      this.dropDownLegal = legalName;
      this.legal.name = legalName;
      this.legal.id = legalId;
      this.merchant.legalId = legalId;
    },
    dropDownLegalBrandClick(legalBrandName, legalBrandId) {
      this.dropDownLegalBrand = legalBrandName;
      this.legalBrand.nameGe = legalBrandName;
      this.legalBrand.id = legalBrandId;
      this.merchant.legalBrandId = legalBrandId;
    },
    modalPrepareEdit() {
      this.isActive = true;
    },
    modalPrepare() {
      this.isActive = false;
    },
    clearData() {
      this.merchant.id = null;
      this.merchant.name = "";
      this.merchant.districtId = null;
      this.merchant.legalId = null;
      this.merchant.legalBrandId = null;
      this.merchant.status = false;
      this.merchant.address = "";
      this.merchant.email = "";
      this.merchant.phone = "";
      this.legal.id = null;
      this.legal.identificationCode = "";
      this.legal.name = "";
      this.legal.password = "";
      this.legal.physicalAddress = "";
      this.legal.legalAddress = "";
      this.legal.mobile = "";
      this.legal.email = "";
      this.legal.dirFirstName = "";
      this.legal.dirLastName = "";
      this.legal.hasMerchant = false;
      this.legal.merchantCout = null;
      this.legal.hasLoyalty = false;
      this.legalBrand.id = null;
      this.legalBrand.nameGe = "";
      this.legalBrand.nameEn = "";
      this.legalBrand.nameRu = "";
      this.legalBrand.descGe = "";
      this.legalBrand.descEn = "";
      this.legalBrand.descRu = "";
      this.legalBrand.logoSrc = null;
      this.legalBrand.lBCategoryId = null;
      this.legalBrand.merchants = [];
      this.dropDownLegal = "აირჩიეთ ორგანიზაცია";
      this.dropDownLegalBrand = "აირჩიეთ ლეგალ ბრენდი";
      this.dropDownProductSubCategory = "აირჩიეთ ლეგალ ბრენდი";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }

// .modal-nav-button {
//   margin-left: 15px;
// }

// .modal-nav {
//   color: #52af8e;
// }

// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// .pointer {
//   cursor: pointer;
// }

// .modal-card {
//   background-color: #eef7f4;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/Merchant.vue